'use strict';

import HCBaseTheme from '../hcbasetheme.es6.js';

/* global lang */
class HCSplineColumn extends HCBaseTheme {
  constructor(container, highlightToday=false) {
    super();

    let self = this;
    let baseColor;

    this.container = container;
    this.highlightToday = highlightToday;

    this.options = {
      plotOptions: {
        column: {
          animation: false,
          color: '#F0F0F0'
        },
        spline: {
          animation: {
            duration: 2500
          },
          color: '#B4B4B4',
          cursor: 'pointer',
          lineWidth: 1,
          marker: {
            fillColor: '#18A5D6',
            radius: 5
          }
        },
        series: {
          point: {
            events: {
              mouseOver() {
                const chart = $(container).highcharts();
                baseColor = chart.series[0].data[this.x].graphic.attr('fill');
                chart.series[0].data[this.x].graphic.attr({ fill: '#CBE4F0' });
              },
              mouseOut() {
                const chart = $(container).highcharts();
                chart.series[0].data[this.x].graphic.attr({ fill: baseColor });
              }
            },
          },
          states: {
            hover: {
              lineWidth: 1
            }
          }
        }
      },
      yAxis: [{
        floor: 0
      }, {
        linkedTo: 0,
        labels: {
          enabled: false
        }
      }],
      series: [{
        type: 'column',
        yAxis: 1,
        enableMouseTracking: false
      }, {
        type: 'spline'
      }]
    };

    this._highlightCurrentDate = this._highlightCurrentDate.bind(this);

    if (this.highlightToday === true) {
      this.options.chart = {
        events: {
          redraw() {
            self._highlightCurrentDate();
          }
        }
      }
    }
  }

  drawChart() {
    if (this.highlightToday === true) {
      super.drawChart(this.container, this.options, this._highlightCurrentDate);
    } else {
      super.drawChart(this.container, this.options);
    }

    return this;
  }

  _highlightCurrentDate() {
    const chart = $(this.container).highcharts();
    const columns = chart.series[0].data;

    for (let i = 0; i < columns.length; ++i) {
      let column = columns[i];

      if (column.category.name === moment().lang(lang).format('L')) {
        column.graphic.attr({ fill: '#C9EAC9' });
      } else {
        column.graphic.attr({ fill: '#F0F0F0' });
      }
    }
  }
}

export default HCSplineColumn;
